module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/sp/en_okinawa-e97f6b1e2e53cb9d27e6dde42214ebec.png";